// extracted by mini-css-extract-plugin
module.exports = {"heading":"NavItemsList_heading__tpvPH","topList":"NavItemsList_topList__nl0tl"};